import type { ReactElement } from "react";
import { MetricWidget } from "./MetricWidget";

/**
 * Core engagement (ISSUE-352 AC4) — sourced from ISSUE-351's core-engagement
 * endpoint, still To Do as of 2026-09-03. AC4 explicitly allows a
 * clearly-labeled not-yet-available placeholder until that endpoint ships,
 * never a fabricated or zero-filled number.
 */
export function CoreEngagementMetricWidget(): ReactElement {
  return (
    <MetricWidget
      title="Core engagement"
      unavailableReason="Sourced from ISSUE-351's core-engagement endpoint, which has not shipped yet."
    />
  );
}
